import React, { useState, useEffect } from 'react';
import BusinessLogin from './BusinessLogin';
import BusinessDashboard from './BusinessDashboard';

const BusinessPortal = () => {
  const [businessUser, setBusinessUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('business_token');
    const user = localStorage.getItem('business_user');
    
    if (token && user) {
      try {
        setBusinessUser(JSON.parse(user));
      } catch (e) {
        localStorage.removeItem('business_token');
        localStorage.removeItem('business_user');
      }
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (user) => {
    setBusinessUser(user);
  };

  const handleLogout = () => {
    setBusinessUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#E8E2D2] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B3A3A]"></div>
      </div>
    );
  }

  if (!businessUser) {
    return <BusinessLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return <BusinessDashboard user={businessUser} onLogout={handleLogout} />;
};

export default BusinessPortal;
